import { useState, useCallback, useEffect } from "react";
import "./App.css";
import Name from "./Name.js";
import ChatContext from "./context";
import ChatBox from "./Chatbox.js";
import Sidebar from "./Sidebar.js";
import { getCredits } from "./send-message.js";

function App() {
  const [store, setStore] = useState({
    name: "",
    messages: [],
    isLoading: false,
    creditsData: null,
  });

  // Fetch credits as soon as the app loads so Overall Remaining is accurate from the start
  useEffect(() => {
    const loadCredits = async () => {
      const data = await getCredits();
      setStore((prev) => ({ ...prev, creditsData: data }));
    };
    loadCredits();
  }, []);

  const updateData = useCallback((newData) => {
    if (typeof newData === "function") {
      setStore(newData);
    } else {
      setStore(newData);
    }
  }, []);

  return (
    <ChatContext.Provider value={{ store, updateData }}>
      <div className="flex flex-col md:flex-row h-screen bg-gradient-to-b from-[#D5D5D5] to-[#E1DFFF] overflow-hidden">
        {/* Mobile: Scrollable container with sidebar first, then chat */}
        <div className="flex flex-col md:hidden h-full overflow-y-auto">
          <Sidebar />
          <ChatBox />
        </div>
        {/* Desktop: Side-by-side layout */}
        <div className="hidden md:flex md:flex-row md:flex-1 md:min-h-0 md:overflow-hidden">
          <Sidebar />
          <ChatBox />
        </div>
        <Name />
      </div>
    </ChatContext.Provider>
  );
}

export default App;

